import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EncroachmentTypeDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-encroachmenttype',
  templateUrl: './encroachmenttype.component.html',
  styleUrls: ['./encroachmenttype.component.scss']
})
export class EncroachmentTypeComponent implements OnChanges {


  encroachmenttypeForm: FormGroup;
  encroachmenttypeFormArray: FormGroup;
  control = new FormControl();
  @Input() encroachmenttypes: EncroachmentTypeDto[];
  @Input() routeAnimationsElements: any;
  @Output() encroachmenttype = new EventEmitter<EncroachmentTypeDto[]>()
  @Output() deleteEncroachmentTypeEvent = new EventEmitter<any>()

    selectedEncroachmentType: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createEncroachmentTypeForm();
    }

    createEncroachmentTypeForm() {
      this.encroachmenttypeForm = this.fb.group({
        EncroachmentTypeName: ['', Validators.required],
      
        id: null
        });
        this.encroachmenttypeFormArray = this.fb.group({ EncroachmentTypes: this.fb.array([])
          });
        this.setEncroachmentType();
    }

  // method to display encroachmenttypes
  setEncroachmentType() {
    const control  = this.encroachmenttypeFormArray.controls.EncroachmentTypes as FormArray;
    this.encroachmenttypes.forEach( e => {
      control.push(
        this.fb.group({
          EncroachmentTypeName: e.EncroachmentTypeName,
         
          id: e.id
        })
      );
    });
  }


  // method to add EncroachmentType
  addEncroachmentType(value: EncroachmentTypeDto) {
    const control  = this.encroachmenttypeFormArray.controls.EncroachmentTypes as FormArray;
    control.insert(0,
          this.fb.group({
            EncroachmentTypeName: value.EncroachmentTypeName,
           
            id: null
          })
       );
  }

  selectEncroachmentType(value) {}

  // method to delete encroachmenttype from arrary list
  deleteEncroachmentType(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.encroachmenttypeFormArray.controls.EncroachmentTypes as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.encroachmenttypes.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.encroachmenttypes[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: EncroachmentTypeDto) {
    if(this.encroachmenttypeForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.encroachmenttypeFormArray.get('EncroachmentTypes')['controls'][this.selectedIndex].patchValue({EncroachmentTypeName: formValue.EncroachmentTypeName});
    } else {
      this.addEncroachmentType(formValue);
    }
    this.selectedIndex = null;
    this.encroachmenttypeForm.reset()
  }

  onEdit(index, value: EncroachmentTypeDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.encroachmenttypeForm.patchValue({EncroachmentTypeName: value.EncroachmentTypeName});
   
  }

  onClearForm() {
    this.selectedIndex = null;
    this.encroachmenttypeForm.reset();
  }

  onSubmit(formValue: EncroachmentTypeDto[]) {
  this.encroachmenttype.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteEncroachmentTypeEvent.emit(this.filteredDelete);
  }
  }

}
